const prefix = '@free-sauce';

export const SHOW_PANEL = `${prefix}/SHOW_PANEL`;
export const HIDE_PANEL = `${prefix}/HIDE_PANEL`;
export const CLEAN_FREE_SAUCES = `${prefix}/CLEAN_FREE_SAUCES`;

export const ADD_TO_CART_REQUEST = `${prefix}/ADD_TO_CART_REQUEST`;
export const ADD_TO_CART_SUCCESS = `${prefix}/ADD_TO_CART_SUCCESS`;
export const ADD_TO_CART_FAILURE = `${prefix}/ADD_TO_CART_FAILURE`;
